import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/home/index.vue'
import Home from '@/views/home/Home.vue'
import List from '@/views/test/list.vue'
import Answer from '@/views/test/answer.vue'
import AnswerWrong from '@/views/test/answerWrong.vue'
import AnswerNote from '@/views/test/answerNote.vue'
import AnswerFavorite from '@/views/test/answerFavorite.vue'
import AnsweRandom from '@/views/test/answeRandom.vue'
import AnswerPastReal from '@/views/test/answerPastReal.vue'
import AnswerSpecialItem from '@/views/test/answerSpecialItem.vue'
import Result from '@/views/test/result.vue'
import Results from '@/views/test/results.vue'
import User from '@/views/user/index.vue'
import UserInfo from '@/views/user/info.vue'
import UserPhoto from '@/views/user/photo.vue'
import UserPassword from '@/views/user/password.vue'
import UserWrong from '@/views/user/wrong.vue'
import UserCollect from '@/views/user/collect.vue'
import UserNote from '@/views/user/note.vue'
import Search from '@/views/search/search.vue'
import SearchDetail from '@/views/search/detail.vue'
import Link from '@/views/home/link.vue'
import Demo from '@/views/home/demo.vue'
import Login from '@/views/login/index.vue'
import Error from '@/views/error/error.vue'
import Searchpage from '@/views/search/searchpage.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Index',
    component: Index,

    children: [
        {
            path: '',
            name: 'List',
            component: List
        },
        {
            path: '/searchpage',
            name: 'Searchpage',
            component: Searchpage
        },
        {
            path: '/answer',
            name: 'Answer',
            component: Answer,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/answerWrong',
            name: 'AnswerWrong',
            component: AnswerWrong,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/answerNote',
            name: 'AnswerNote',
            component: AnswerNote,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/answerFavorite',
            name: 'AnswerFavorite',
            component: AnswerFavorite,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/answeRandom',
            name: 'AnsweRandom',
            component: AnsweRandom
        },
        {
            path: '/answerSpecialItem',
            name: 'AnswerSpecialItem',
            component: AnswerSpecialItem,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/answerPastReal',
            name: 'AnswerPastReal',
            component: AnswerPastReal,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/result',
            name: 'Result',
            component: Result,
        }, {
            path: '/results',
            name: 'Results',
            component: Results,
        },
        {
            path: '/user',
            name: 'User',
            component: User,
            meta: {
                requireAuth: false
            },
            children: [{
                path: '/',
                name: 'UserInfo',
                component: UserInfo,
            },
            {
                path: '/user/photo',
                name: 'UserPhoto',
                component: UserPhoto,
            },
            {
                path: '/user/password',
                name: 'UserPassword',
                component: UserPassword,
            },
            {
                path: '/user/wrong',
                name: 'UserWrong',
                component: UserWrong,
            },
            {
                path: '/user/collect',
                name: 'UserCollect',
                component: UserCollect,
            },
            {
                path: '/user/note',
                name: 'UserNote',
                component: UserNote,
            },

            ]
        },
        {
            path: '/search',
            name: 'Search',
            component: Search
        },
        {
            path: '/detail',
            name: 'SearchDetail',
            component: SearchDetail
        },
        {
            path: '/link',
            name: 'Link',
            component: Link,
        },

    ]

},
{
    path: '/link',
    name: 'Link',
    component: Link,
},
{
    path: '/login',
    name: 'Login',
    component: Login
},
{
    path: '/demo',
    name: 'Demo',
    component: Demo
},
{
    path: '/error',
    name: 'Error',
    component: Error
},



    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]




const router = new VueRouter({
    routes,
    mode: 'history'
})





export default router